import { useRef } from 'react'

export const useFormRef = <T>() => {
  const ref = useRef<{ validateFields:() => Promise<T>; } | null>(null)
  return ref
}
